import React from "react";
import { Typography, Stack, Button, useMediaQuery } from "@mui/material";
import { Controller } from "react-hook-form";

import { SearchAutocomplete } from "../../../components/molecules";
import { issueReportFormSteps } from ".";
import { colors } from "../../../const";

type StepProps = {
  setStep: (currentStep: number) => void;
  formOptions: any;
  predefinedParams: any;
};

const styles = {
  stepLabel: {
    color: colors.halfTransparentBlue,
  },
  subtitle: {
    color: colors.halfTransparentBlue,
  },
  input: {
    "& .MuiAutocomplete-input": {
      color: `${colors.defaultWhite}!important`,
    },
    input: { color: `${colors.defaultWhite}!important` },
    color: `${colors.defaultWhite}!important`,

    borderColor: `${colors.activeGreen}!important`,
  },
  nextButton: {
    backgroundColor: colors.activeGreen,
    borderRadius: "20px",
    width: "150px",
    "&:hover": {
      backgroundColor: colors.activeGreen,
      opacity: 0.8,
    },
  },
};

export const LocationFormStep: React.FC<StepProps> = ({
  setStep,
  formOptions,
  predefinedParams,
}) => {
  const { control, errors, watch } = formOptions;
  const locationWatch = watch("location");
  const isWidth450pxOrLess = useMediaQuery("(max-width: 450px)");

  return (
    <Stack p={isWidth450pxOrLess ? 2 : 7} height="100%" width="90%">
      <Stack spacing={1}>
        {!isWidth450pxOrLess && (
          <Typography typography="h6" sx={styles.stepLabel}>
            Step 1/4
          </Typography>
        )}
        <Typography typography={isWidth450pxOrLess ? "h4" : "h5"}>
          Start with the location
        </Typography>
        <Typography
          typography={isWidth450pxOrLess ? "subtitle1" : "subtitle2"}
          sx={styles.subtitle}
        >
          Please tell us where the issue has occurred using the dropdown below
          if needed
        </Typography>
      </Stack>
      <Stack spacing={4} mt={3}>
        <Controller
          name="location"
          control={control}
          render={({ field: { value, onChange } }) => (
            <SearchAutocomplete
              value={value}
              disabled={!!predefinedParams?.location.id}
              textFieldProps={{
                error: !!errors.location,
                helperText: errors.location?.message,
              }}
              color={colors.defaultWhite}
              onChange={(_, newValue) => onChange(newValue)}
              options={[]}
            />
          )}
        />
        {locationWatch && predefinedParams?.sublocation && (
          <Controller
            name="sublocation"
            control={control}
            render={({ field: { value, onChange } }) => (
              <SearchAutocomplete
                value={value}
                disabled={!!predefinedParams?.sublocation?.id}
                textFieldProps={{
                  color: "primary",
                  error: !!errors.sublocation,
                  helperText: errors.sublocation?.message,
                }}
                color="primary"
                onChange={(_, newValue) => onChange(newValue)}
                options={[]}
              />
            )}
          />
        )}
      </Stack>

      <Stack
        direction="row"
        justifyContent={isWidth450pxOrLess ? "flex-start" : "flex-end"}
        ml={isWidth450pxOrLess ? 2 : 0}
        mt={"auto"}
      >
        <Button
          onClick={() => setStep(issueReportFormSteps.ISSUE_TYPE)}
          sx={styles.nextButton}
          size="large"
          variant="contained"
        >
          Next step
        </Button>
      </Stack>
    </Stack>
  );
};
